import { createFileRoute } from "@tanstack/react-router";
import { useContent } from "@/lib/use-content";
import { Phone, MapPin, CalendarCheck, Users, MessageSquare, Sparkles } from "lucide-react";

export const Route = createFileRoute("/register")({
  head: () => ({
    meta: [
      { title: "הרשמה | ישיבת תורת חיים" },
      { name: "description", content: "תהליך ההרשמה לישיבת תורת חיים - תיאום פגישה, מהלך הפגישה וקבלת תשובה." },
    ],
  }),
  component: Register,
});

const STEP_ICONS = [CalendarCheck, Users, MessageSquare, Sparkles];

function Register() {
  const c = useContent("registration");
  const steps: Array<{ title: string; text: string }> = c.steps ?? [];

  return (
    <>
      <section className="bg-primary text-primary-foreground py-20">
        <div className="container mx-auto px-4 text-center">
          <div className="mx-auto mb-4 h-px w-16 bg-gold" />
          <h1 className="font-display text-5xl font-bold">{c.title}</h1>
          <p className="mt-3 text-xl text-gold font-display">{c.subtitle}</p>
        </div>
      </section>

      <section className="container mx-auto px-4 py-16 max-w-4xl">
        <ol className="relative space-y-8">
          {steps.map((step, i) => {
            const Icon = STEP_ICONS[i] ?? CalendarCheck;
            return (
              <li
                key={i}
                className="relative rounded-lg bg-card p-6 md:p-8 shadow-card border border-border/50"
              >
                <div className="flex items-start gap-5">
                  <div className="flex-none flex flex-col items-center">
                    <div className="flex h-14 w-14 items-center justify-center rounded-full gradient-gold text-gold-foreground shadow-elegant">
                      <Icon className="h-6 w-6" />
                    </div>
                    <span className="mt-2 font-display text-2xl font-bold text-primary">
                      {i + 1}
                    </span>
                  </div>
                  <div className="flex-1 pt-1">
                    <h2 className="font-display text-2xl font-bold text-primary">
                      {step.title}
                    </h2>
                    <p className="mt-3 text-foreground/80 leading-relaxed whitespace-pre-line">
                      {step.text}
                    </p>
                  </div>
                </div>
              </li>
            );
          })}
        </ol>

        <div className="mt-12 rounded-lg bg-primary text-primary-foreground p-8 text-center shadow-elegant">
          <p className="font-display text-lg text-gold">לתיאום פגישה</p>
          <a
            href={`tel:${(c.phone ?? "").replace(/[^\d+]/g, "")}`}
            className="mt-2 inline-flex items-center gap-3 font-display text-4xl md:text-5xl font-bold hover:text-gold transition-colors"
            dir="ltr"
          >
            <Phone className="h-7 w-7" />
            {c.phone}
          </a>
          {c.address && (
            <p className="mt-4 inline-flex items-center gap-2 text-primary-foreground/80">
              <MapPin className="h-4 w-4" /> {c.address}
            </p>
          )}
        </div>
      </section>
    </>
  );
}
